/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Workout_Progress_LabelInputs */

const en_us2_workout_progress_label = /** @type {(inputs: Workout_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercise ${i?.current} of ${i?.total}. See all exercises`)
};

const pt_br2_workout_progress_label = /** @type {(inputs: Workout_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercício ${i?.current} de ${i?.total}. Ver todos os exercícios`)
};

const es_419_workout_progress_label = /** @type {(inputs: Workout_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ejercicio ${i?.current} de ${i?.total}. Ver todos los ejercicios`)
};

const pt_pt2_workout_progress_label = /** @type {(inputs: Workout_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercício ${i?.current} de ${i?.total}. Ver todos os exercícios`)
};

const fr_fr2_workout_progress_label = /** @type {(inputs: Workout_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercice ${i?.current} sur ${i?.total}. Voir tous les exercices`)
};

const de_de2_workout_progress_label = /** @type {(inputs: Workout_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Übung ${i?.current} von ${i?.total}. Alle Übungen ansehen`)
};

const it_it2_workout_progress_label = /** @type {(inputs: Workout_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esercizio ${i?.current} di ${i?.total}. Vedi tutti gli esercizi`)
};

/**
* | output |
* | --- |
* | "Exercise {current} of {total}. See all exercises" |
*
* @param {Workout_Progress_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_progress_label = /** @type {((inputs: Workout_Progress_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Progress_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_progress_label(inputs)
	if (locale === "es-419") return es_419_workout_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_progress_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_progress_label(inputs)
	if (locale === "de-DE") return de_de2_workout_progress_label(inputs)
	if (locale === "it-IT") return it_it2_workout_progress_label(inputs)
	return en_us2_workout_progress_label(inputs)
});
export { workout_progress_label as "workout.progress_label" }